// src/features/academic/utils/timeUtils.js
/**
 * Time Utilities
 * Helper functions for time-related operations in the quiz
 */

/**
 * Formats time remaining in seconds to a display string
 * @param {number} seconds - Time remaining in seconds
 * @returns {string} Formatted time string
 */
export const formatTimeRemaining = (seconds) => {
  if (seconds <= 0) return '0:00';
  
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = Math.floor(seconds % 60);
  
  return `${minutes}:${remainingSeconds.toString().padStart(2, '0')}`;
};

/**
 * Gets appropriate text color class based on time remaining
 * @param {number} timeLeft - Time remaining in seconds
 * @param {number} totalTime - Total time allowed in seconds
 * @returns {string} Tailwind text color class
 */
export const getTimeColor = (timeLeft, totalTime) => {
  // Calculate percentage of time remaining
  const percentRemaining = (timeLeft / totalTime) * 100;
  
  if (percentRemaining <= 20) return 'text-red-500'; // Critical (≤20%)
  if (percentRemaining <= 50) return 'text-amber-500'; // Warning (≤50%)
  return 'text-green-500'; // Good (>50%)
};

export default {
  formatTimeRemaining,
  getTimeColor
};